import { useSearchCompanyPatients } from "features/search-company-patients";
import { useState, useCallback } from "react";
import { AutocompleteInput } from "react-admin";
import { unionBy } from 'lodash';

type Props = {
  companyId: string;
  onChange?: (value: string[]) => void;
  label?: string;
  source: string;
}

export const SearchCompanyPatientInput = ({ companyId, onChange, label, source }: Props) => {
  const { searchCompanyPatients, isLoading } = useSearchCompanyPatients({ companyId });
  const [choices, setChoices] = useState<{ id: string; name: string }[]>([]);

  const handleSearch = useCallback(async (searchValue: string) => {
    if (!searchValue || searchValue.length < 2) {
      return;
    }

    const response = await searchCompanyPatients({ email: searchValue });
    
    if (response?.data) {
      const newChoices = response.data.map((patient: any) => ({
        id: patient.userId,
        name: patient.email,
      }));

      setChoices(prev => unionBy([...prev, ...newChoices], 'id'));
    }
  }, [searchCompanyPatients]);

  const updateUserIds = useCallback((value: string[]) => {
    onChange?.(value);
  }, [onChange]);

  return (
    <AutocompleteInput
      setFilter={handleSearch}
      label={label || "Поиск пациента по email"}
      source={source}
      choices={choices}
      isLoading={isLoading}
      fullWidth
      optionText="name"
      optionValue="id"
      multiple
      onChange={updateUserIds}
    />
  );
};